/*
 * NFT Landing Page - Sailing Ships Collection
 * Copyright (C) 2025 jsaif
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 *
 * Original project: https://github.com/s-shemmee/NFT-Portfolio-Landing-Page
 * Original creator: s-shemmee
 */

import React, { useState } from "react";
import "./QnA.css";

export default function QnA() {
  // Separate states for each card's active question
  const [activeQuestionLeft, setActiveQuestionLeft] = useState(null);
  const [activeQuestionRight, setActiveQuestionRight] = useState(null);

  const toggleAnswerLeft = (questionId) => {
    setActiveQuestionLeft((prevQuestionId) => (prevQuestionId === questionId ? null : questionId));
  };

  const toggleAnswerRight = (questionId) => {
    setActiveQuestionRight((prevQuestionId) => (prevQuestionId === questionId ? null : questionId));
  };

  const questions = [
    {
      id: 1,
      question: "What is 'Sailing Through Time & Dreams' NFT Collection?",
      answer:
        "It's a unique NFT collection where each sailing ship is crafted from precious gemstones and tells its own story. Each ship represents a journey through time and imagination, combining mythical elements with stunning AI-driven artistry.",
    },
    {
      id: 2,
      question: "How can I mint or purchase these NFTs?",
      answer:
        "You can mint our NFTs directly through our Genesis Mint on XRP.cafe. The collection is currently live and available for minting on the XRPL (XRP Ledger) blockchain. Visit our collection page to start your journey.",
    },
    {
      id: 3,
      question: "Why choose Sailing Ships over other NFT collections?",
      answer:
        "Our collection offers deep storytelling, immersive lore, and community engagement beyond just art. Each ship comes with narrative videos, potential airdrops of animated NFTs, and access to an evolving digital legacy that connects across social platforms.",
    },
    {
      id: 4,
      question: "What blockchain is this collection built on?",
      answer:
        "We're built on the XRP Ledger (XRPL), which offers fast, low-cost transactions and eco-friendly minting. This choice ensures accessibility for collectors while maintaining the security and authenticity of your digital assets.",
    },
    {
      id: 5,
      question: "What utilities and benefits do holders receive?",
      answer:
        "Holders gain access to exclusive storytelling content, potential animated NFT airdrops, community events, and participation in the evolving lore of their ships. Each NFT serves as a key to deeper engagement with our expanding universe.",
    },
    {
      id: 6,
      question: "How many ships are in the collection?",
      answer:
        "The Genesis collection features 2000 unique sailing ships, each one crafted from different combinations of gemstones including ruby, sapphire, emerald, diamond, amethyst, and topaz. Every ship has its own distinct personality and story.",
    },
    {
      id: 7,
      question: "Can I see the story or lore behind my ship?",
      answer:
        "Absolutely! Each ship comes with rich backstory and narrative content. We create storytelling videos and immersive lore that brings your ship's journey to life, making it more than just a static image.",
    },
    {
      id: 8,
      question: "Are there plans for future collections or expansions?",
      answer:
        "Yes! This is just the beginning of our sailing universe. We have plans for animated NFT airdrops to holders, expanded storytelling content, and potentially new voyages with additional ship classes and adventures.",
    },
  ];

  return (
    <section className="QnA" id="qna">
      <div className="container-fluid">
        <div className="row">
          <h2>
            <span>ASKED QUESTIONS</span>
          </h2>
        </div>
        <div className="row">
          <div className="col-md-6 card">
            {questions.slice(0, 4).map((q, index) => (
              <div className="question" key={q.id}>
                <button
                  onClick={() => toggleAnswerLeft(q.id)}
                  data-active={activeQuestionLeft === q.id}
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <h5>
                    {q.question}
                    {activeQuestionLeft === q.id ? (
                      <i className="bi bi-dash-lg"></i>
                    ) : (
                      <i className="bi bi-plus-lg"></i>
                    )}
                  </h5>
                </button>
                {activeQuestionLeft === q.id && <p>{q.answer}</p>}
                {index !== 3 && <hr />}
              </div>
            ))}
          </div>

          <div className="col-md-6 card">
            {questions.slice(4, 8).map((q, index) => (
              <div className="question" key={q.id}>
                <button
                  onClick={() => toggleAnswerRight(q.id)}
                  data-active={activeQuestionRight === q.id}
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <h5>
                    {q.question}
                    {activeQuestionRight === q.id ? (
                      <i className="bi bi-dash-lg"></i>
                    ) : (
                      <i className="bi bi-plus-lg"></i>
                    )}
                  </h5>
                </button>
                {activeQuestionRight === q.id && <p>{q.answer}</p>}
                {index !== 3 && <hr />}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
